/**
 * Loại chỉ tiêu tổng hợp
 */
export default {
  /// <summary>
  /// Thu NSNN
  /// </summary>
  Revenue: 1,

  /// <summary>
  /// Chi thường xuyên
  /// </summary>
  Regular: 2,
};
